import { render, staticRenderFns } from "./DailyChatLoader.vue?vue&type=template&id=865d9556&scoped=true"
import script from "./DailyChatLoader.vue?vue&type=script&lang=js"
export * from "./DailyChatLoader.vue?vue&type=script&lang=js"
import style0 from "./DailyChatLoader.vue?vue&type=style&index=0&id=865d9556&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865d9556",
  null
  
)

export default component.exports